var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review-agent-notes"},[_c('div',{staticClass:"panel",attrs:{"boxed":""}},[_c('div',{staticClass:"review--title--small"},[_vm._v("Osservazioni importanti dal tuo consulente di viaggio:")]),_c('div',{staticClass:"tiny-mce italic",domProps:{"innerHTML":_vm._s(_vm.agent_notes)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }